import { timeZonesList } from '@/contants/timeZones';
import i18n from 'i18next';
import FormSelectBox from '../Inputs/FormSelectBox';

const TimeZoneSelectorHB = ({
  placeholder = i18n.t('translation:default.fields.timeZone.placeholder'),
  label = i18n.t('translation:default.fields.timeZone.label'),
  rules = [],
  name,
  editMode,
  handleChange = () => {},
}) => {
  return (
    <FormSelectBox
      options={timeZonesList.timeZones?.map((row) => ({
        label: row.displayName,
        value: row.windowsTimeZoneId,
        ianaTimeZoneId: row.ianaTimeZoneId,
      }))}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={handleChange}
    />
  );
};

export default TimeZoneSelectorHB;
